(function () {
  async function fetchCart() {
    const res = await fetch(`${Shopify.routes.root}cart.js`, {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    });
    if (!res.ok) throw new Error("cart.js failed");
    return res.json();
  }

  async function updateCartAttributes(attributes) {
    const res = await fetch(`${Shopify.routes.root}cart/update.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ attributes }),
    });
    if (!res.ok) throw new Error("cart/update.js failed");
    return res.json();
  }

  async function updateLinePropertiesByLine(line, properties) {
    const res = await fetch(`${Shopify.routes.root}cart/change.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ line, properties }),
    });
    if (!res.ok) throw new Error("cart/change.js failed");
    return res.json();
  }

  function findCheckoutButtons() {
    const selectors = [
      'form[action^="/cart"] button[name="checkout"]',
      'form[action^="/cart"] input[name="checkout"]',
      'button[name="checkout"]',
      'input[name="checkout"]',
      'button[type="submit"][name="checkout"]'
    ];
    const nodes = new Set();
    selectors.forEach(sel => document.querySelectorAll(sel).forEach(n => nodes.add(n)));
    return Array.from(nodes);
  }

  function setCheckoutEnabled(enabled) {
    const btns = findCheckoutButtons();
    btns.forEach((b) => {
      b.disabled = !enabled;
      b.setAttribute("aria-disabled", String(!enabled));
      if (!enabled) b.classList.add("is-disabled");
      else b.classList.remove("is-disabled");
    });
  }

  function findAddToCartButtons(scope) {
    const form = scope.closest('form[action^="/cart/add"]') || document.querySelector('form[action^="/cart/add"]');
    if (!form) return [];
    const btns = new Set();
    form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach(b => btns.add(b));
    return Array.from(btns);
  }

  function setAddToCartEnabled(scope, enabled) {
    const btns = findAddToCartButtons(scope);
    btns.forEach((b) => {
      b.disabled = !enabled;
      b.setAttribute("aria-disabled", String(!enabled));
      if (!enabled) b.classList.add("is-disabled");
      else b.classList.remove("is-disabled");
    });
  }

  function ensureHiddenProperty(form, name, value) {
    if (!form) return;
    const selector = `input[type="hidden"][name="properties[${CSS.escape(name)}]"]`;
    let input = form.querySelector(selector);
    if (!input) {
      input = document.createElement("input");
      input.type = "hidden";
      input.name = `properties[${name}]`;
      form.appendChild(input);
    }
    input.value = value || "";
  }

  function toLocalDateFromInput(value) {
    if (!value) return null;
    const d = new Date(`${value}T00:00:00`);
    return Number.isNaN(d.getTime()) ? null : d;
  }
/*
  function isSunday(value) {
    const d = toLocalDateFromInput(value);
    if (!d) return false;
    return d.getDay() === 0;
  } */

function isSunday(value) {
  const d = toLocalDateFromInput(value);
  if (!d) return false;

  // Excepción: domingo 3 de mayo de 2026
  if (
    d.getFullYear() === 2026 &&
    d.getMonth() === 4 && // mayo (0 = enero)
    d.getDate() === 3
  ) {
    return false;
  }

  return d.getDay() === 0;
}


  // ✅ MODIFICACIÓN (min date): helper para "mañana" en formato YYYY-MM-DD
  function getTomorrowISO() {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + 1); // mañana (bloquea hoy y pasadas)
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  }

  // ✅ MODIFICACIÓN: helper para detectar si la fecha seleccionada es HOY (local)
  function isToday(value) {
    const d = toLocalDateFromInput(value);
    if (!d) return false;
    const t = new Date();
    t.setHours(0, 0, 0, 0);
    return d.getTime() === t.getTime();
  }

  // ✅ MODIFICACIÓN (NUEVA): helper para detectar si la fecha seleccionada es PASADA (local)
  function isPastDate(value) {
    const d = toLocalDateFromInput(value);
    if (!d) return false;
    const t = new Date();
    t.setHours(0, 0, 0, 0);
    return d.getTime() < t.getTime();
  }

  function initOne(root) {
    if (root.dataset.dtInit === "1") return;
    root.dataset.dtInit = "1";

    const context = root.dataset.context || "cart"; // cart | product

    const requireDateCart = root.dataset.requireDateCart === "true";
    const requireDateProduct = root.dataset.requireDateProduct === "true";
    const requireDate = context === "product" ? requireDateProduct : requireDateCart;

    const copyToLines = root.dataset.copyToLines === "true";
    const showInstructions = root.dataset.showInstructions === "true";

    const attrDate = root.dataset.attrDate || "delivery_date";
    const attrMethod = root.dataset.attrMethod || "delivery_method";
    const attrInstructions = root.dataset.attrInstructions || "delivery_instructions";

    const propDate = root.dataset.propDate || "Fecha de entrega";
    const propMethod = root.dataset.propMethod || "Tipo de entrega";
    const propInstructions = root.dataset.propInstructions || "Instrucciones";

    const tabs = root.querySelectorAll("[data-dt-fed-method]");
    const dateInput = root.querySelector("[data-dt-fed-date]");
    const instructionsEl = root.querySelector("[data-dt-fed-instructions]");
    const statusEl = root.querySelector("[data-dt-fed-status]");
    const errorDateEl = root.querySelector("[data-dt-fed-error-date]") || root.querySelector("[data-dt-fed-error]");

    let activeMethod = "shipping";

    // ✅ MODIFICACIÓN: usamos mensaje traducible desde el snippet (data-error-sunday)
    const errorSundayMsg = (root.dataset.errorSunday || "").trim();

    // ✅ MODIFICACIÓN: domingo bloqueado en envío a domicilio (shipping) y recogida (pickup)
    const SUNDAY_BLOCKED_METHODS = new Set(["shipping", "pickup"]);

    // ✅ MODIFICACIÓN (min date): bloquea seleccionar HOY y fechas pasadas (min = mañana)
    if (dateInput) dateInput.min = getTomorrowISO();

    function validate() {
      const dateVal = dateInput ? dateInput.value : "";
      const hasDate = !!dateVal;
      const hasMethod = !!activeMethod;

      // ✅ MODIFICACIÓN: si el cliente elige domingo y el método es shipping/pickup => inválido
      const sundayBlocked = hasDate && SUNDAY_BLOCKED_METHODS.has(activeMethod) && isSunday(dateVal);

      // ✅ MODIFICACIÓN: si el cliente elige HOY en PDP, bloqueamos el botón de añadir al carrito
      const todayBlockedOnPDP = (context === "product") && hasDate && isToday(dateVal);

      // ✅ MODIFICACIÓN (NUEVA): si el cliente elige una fecha PASADA en PDP, bloqueamos el botón de añadir al carrito
      const pastBlockedOnPDP = (context === "product") && hasDate && isPastDate(dateVal);

      // Reglas base (si es obligatorio, necesita fecha + método)
      let ok = (!requireDate) || (hasDate && hasMethod);

      // ✅ MODIFICACIÓN: aunque NO sea obligatorio, si ha elegido fecha y es domingo bloqueado => no permitir
      if (sundayBlocked) ok = false;

      // ✅ MODIFICACIÓN: bloquear en PDP si es HOY
      if (todayBlockedOnPDP) ok = false;

      // ✅ MODIFICACIÓN (NUEVA): bloquear en PDP si es fecha pasada
      if (pastBlockedOnPDP) ok = false;

      if (context === "cart") {
        setCheckoutEnabled(ok);
      } else {
        setAddToCartEnabled(root, ok);
      }

      if (errorDateEl) {
        const showRequiredError = requireDate && !hasDate;

        // mostramos error si: falta fecha obligatoria o domingo bloqueado
        errorDateEl.hidden = !showRequiredError && !sundayBlocked;

        // ✅ MODIFICACIÓN: texto de domingo desde traducción
        if (sundayBlocked && errorSundayMsg) {
          errorDateEl.textContent = errorSundayMsg;
        }
      }

      if (statusEl) {
        if (sundayBlocked && errorSundayMsg) statusEl.textContent = errorSundayMsg;
        else statusEl.textContent = "";
      }

      return ok;
    }

    function setActiveMethod(method) {
      activeMethod = method;
      tabs.forEach((t) => t.classList.toggle("is-active", t.dataset.dtFedMethod === method));

      if (context === "cart") {
        persistCart({ onlyMethod: true }).catch(() => {});
      } else {
        persistProductProperties();
      }

      validate();
    }

    tabs.forEach((btn) => btn.addEventListener("click", () => setActiveMethod(btn.dataset.dtFedMethod)));

    async function persistCart(opts = {}) {
      const onlyMethod = !!opts.onlyMethod;

      const dateVal = dateInput ? dateInput.value : "";
      const instructionsVal = (showInstructions && instructionsEl) ? (instructionsEl.value || "").trim() : "";

      if (!onlyMethod && requireDate && !dateVal) {
        validate();
        return;
      }

      if (statusEl) statusEl.textContent = "Guardando…";

      const attributes = {};
      attributes[attrMethod] = activeMethod;
      if (!onlyMethod) {
        attributes[attrDate] = dateVal;
        if (showInstructions) attributes[attrInstructions] = instructionsVal;
      }
      await updateCartAttributes(attributes);

      if (copyToLines && !onlyMethod) {
        const cart = await fetchCart();
        for (let i = 0; i < cart.items.length; i++) {
          const line = i + 1;
          const item = cart.items[i];
          const props = Object.assign({}, item.properties || {});
          props[propMethod] = activeMethod;
          props[propDate] = dateVal;
          if (showInstructions) props[propInstructions] = instructionsVal;
          await updateLinePropertiesByLine(line, props);
        }
      }

      if (statusEl) statusEl.textContent = "Guardado.";
      validate();
      document.dispatchEvent(new CustomEvent("cart:refresh"));
    }

    function persistProductProperties() {
      const form = root.closest('form[action^="/cart/add"]') || document.querySelector('form[action^="/cart/add"]');
      if (!form) return;

      const dateVal = dateInput ? dateInput.value : "";
      const instructionsVal = (showInstructions && instructionsEl) ? (instructionsEl.value || "").trim() : "";

      ensureHiddenProperty(form, propMethod, activeMethod);
      ensureHiddenProperty(form, propDate, dateVal);
      if (showInstructions) ensureHiddenProperty(form, propInstructions, instructionsVal);

      if (!dateVal) ensureHiddenProperty(form, propDate, "");
      if (showInstructions && !instructionsVal) ensureHiddenProperty(form, propInstructions, "");
    }

    if (context === "cart") {
      fetchCart().then((cart) => {
        const a = cart.attributes || {};
        if (a[attrMethod]) activeMethod = a[attrMethod];
        tabs.forEach((t) => t.classList.toggle("is-active", t.dataset.dtFedMethod === activeMethod));

        if (dateInput && a[attrDate]) dateInput.value = a[attrDate];
        if (showInstructions && instructionsEl && a[attrInstructions]) instructionsEl.value = a[attrInstructions];

        validate();
      }).catch(() => validate());
    } else {
      tabs.forEach((t) => t.classList.toggle("is-active", t.dataset.dtFedMethod === activeMethod));
      validate();
      persistProductProperties();
    }

    dateInput?.addEventListener("change", () => {
      // ✅ MODIFICACIÓN (min date): re-aplicamos min por si el theme re-renderiza el input
      if (dateInput) dateInput.min = getTomorrowISO();

      if (context === "cart") {
        persistCart({ onlyMethod: false }).catch(() => {
          if (statusEl) statusEl.textContent = "No se pudo guardar. Reintenta.";
        });
      } else {
        persistProductProperties();
        validate();
      }
    });

    instructionsEl?.addEventListener("blur", () => {
      if (context === "cart") {
        persistCart({ onlyMethod: false }).catch(() => {
          if (statusEl) statusEl.textContent = "No se pudo guardar. Reintenta.";
        });
      } else {
        persistProductProperties();
        validate();
      }
    });

    validate();
  }

  function initAll() {
    document.querySelectorAll(".dt-fed-card[id^='dt-fed-']").forEach(initOne);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  document.addEventListener("cart:updated", initAll);
  document.addEventListener("cart:build", initAll);
  document.addEventListener("cart:refresh", initAll);
})();